module.exports = require("./lkt.js");